<template>
  <div class="header-section" ref="targetRef">
    <div id="video-container" class="video-container">
      <video
        id="index-video"
        class="index-video"
        autoplay
        muted
        loop
        playsinline
        webkit-playsinline="true"
        mtt-playsinline="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portrait"
        disablePictureInPicture
      ></video>
      <div class="slogan"></div>
    </div>

    <div class="top-container" v-if="!isMobile">
      <div class="game-logo"></div>

      <div class="action-buttons">
        <!-- 未登录：显示登入按钮 -->
        <button v-if="!isLogin" class="action-btn" @click="gotoLogin()">
          <span class="btn-text">{{ langData.loginBtn }}</span>
        </button>

        <!-- 已登录：显示账号信息（替换登入按钮的位置） -->
        <div v-else class="user-info-container">
          <span class="account-text">
            {{ langData.accountLabel }}{{ accountName }}
            <template v-if="isBind">
              <span style="margin-left: 20px;">伺服器：{{ sname }}</span>
              <span style="margin-left: 20px;">角色：{{ roleName }}</span>
            </template>
          </span>
          <span class="action-link" @click="handleBindOrSwitchRole()">
            {{ isBind ? langData.switchRoleBtn : langData.bindRoleBtn }}
          </span>
          <span class="action-link" @click="logout()">
            {{ langData.logoutBtn }}
          </span>
        </div>

        <!-- 进入官网按钮（始终显示） -->
        <button class="action-btn" @click="handleOfficialWebsite()">
          <span class="btn-text">進入官網</span>
        </button>

        <!-- 下载游戏按钮（始终显示） -->
        <button class="action-btn" @click="handleDownloadGame()">
          <span class="btn-text">下載遊戲</span>
        </button>
      </div>
    </div>

    <!-- 新增内容区域 -->
    <div class="center-content-container" v-if="!isMobile">
      <!-- 第一行：标题 + 播放按钮 + 副标题 -->
      <div class="title-row">
        <span class="title-text">3月26日全新版本更新</span>
        <!-- <div class="play-btn" @click="handlePlayVideo"></div> -->
        <span class="title-text">超多福利期待你的參與</span>
      </div>

      <!-- 第二行：SLOGAN占位 -->
      <div class="slogan-placeholder"></div>

      <!-- 第三行：预约按钮 -->
      <div class="reserve-section">
        <!-- 已预约状态 -->
        <div v-if="isReserved" class="reserved-btn"></div>
        <!-- 未预约状态 -->
        <div v-else class="reserve-btn" @click="handleReserve()"></div>

        <!-- 提示文字 -->
        <div class="reserve-tip-row" @click="scrollToMilestone">
          <div class="text-decoration-left"></div>
          <span class="reserve-tip-text">下滑參與版本預約活動，查看更多福利內容</span>
          <div class="text-decoration-right"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";
import LanguageHook from "@/hooks/language";
import bridge from "@/utils/sdkBridge";
import { systemType, pointClickButton } from "@/utils";
import useViewPagePoint from "@/hooks/useViewPagePoint";

// 页面视图打点
const { targetRef } = useViewPagePoint("首页");

// 语言相关
const { langData } = LanguageHook();

// 注入的数据
const isLogin = inject("isLogin");
const accountName = inject("accountName");
const isBind = inject("isBind");
const roleName = inject("roleName");
const sname = inject("sname");
const isMobile = inject("isMobile");
const isReserved = inject("isReserved");
const showVideoPopup = inject("showVideoPopup");

// Props & Emits
const emit = defineEmits(["gotoLogin", "logout", "bindRole", "switchRole", "reserve"]);

// 下载游戏配置
const pageData = {
  onelink: 'https://pse.is/8l9qfh',
  gameId: 386,
  pcClientLink: 'https://gevents.gnjoy.hk/exe/rolk/RO仙境傳說：世界之旅_official_downloaders_install.exe',
  packageName: 'com.global.roworld.pc'
};

// 方法
const gotoLogin = () => {
  pointClickButton("登入按钮", "首页");
  emit("gotoLogin");
};

const logout = () => {
  pointClickButton("登出按钮", "首页");
  emit("logout");
};

const handleBindOrSwitchRole = () => {
  if (isBind.value) {
    pointClickButton("切换角色按钮", "首页");
    emit("switchRole");
  } else {
    pointClickButton("绑定角色按钮", "首页");
    emit("bindRole");
  }
};

const handleReserve = () => {
  pointClickButton("预约按钮", "首页");
  emit("reserve");
};

const handleOfficialWebsite = () => {
  pointClickButton("进入官网按钮", "首页");
  const link = 'https://gwww.gnjoy.hk/rotwgw/index.html#/';
  bridge.open(window.globalGetGotoLink?.({ link }) || link);
};

const handleDownloadGame = () => {
  pointClickButton("下载游戏按钮", "首页");
  const deviceSystem = systemType(); // 返回 'ios', 'android' 或 'pc'

  if (deviceSystem !== 'pc') {
    // 移动端（iOS/Android）：打开 onelink
    let curLink = window.globalAdPoint.getAdLink('onelink', pageData.onelink);
    bridge.open(curLink);
  } else {
    // PC 端：调用 handleClientDownload 并埋点
    window.handleClientDownload?.({
      gameId: pageData.gameId,
      link: pageData.pcClientLink,
      packageName: pageData.packageName,
    });
    window.globalAdPoint?.point?.('pc');
  }
};  

const handlePlayVideo = () => {
  pointClickButton("播放视频按钮", "首页");
  // TODO: 替换为实际的视频URL
  const videoSrc = 'https://example.com/video.mp4';
  showVideoPopup(videoSrc);
};

const scrollToMilestone = () => {
  const scrollDistance = (1180 / 1920) * window.innerWidth;
  window.scrollTo({
    top: scrollDistance,
    behavior: 'smooth'
  });
};
</script>
